import { IScreen } from "screen/model"
import { screenRPO } from "screen/repository"

export const getScreensByIds = (screenIds: string[]): Promise<IScreen[]> => screenRPO.getScreensByIds(screenIds)
